import React from 'react'
import AsyncSelect from 'react-select/async'

export default props => (
  <AsyncSelect
    placeholder="Selecionar"
    {...props}
  />
)
